"use strict";import{tag as r}from"../custom-tag.js";export function homeIcon({height:a=16,width:e=16,hidden:t=!1,title:l="Home"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <mask
        id="home_svg__mask0_6875_6147"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M21.444 21.946h-6.666a.556.556 0 0 1-.556-.556v-7.222H9.778v7.222a.556.556 0 0 1-.556.556H2.644a.567.567 0 0 1-.555-.556L2 10.835a.58.58 0 0 1 .189-.423l9.444-8.277a.57.57 0 0 1 .734 0l9.444 8.322a.53.53 0 0 1 .189.378V21.39a.555.555 0 0 1-.556.556m-6.11-1.111h5.555v-9.767L12 3.29l-8.889 7.778.089 9.767h5.467v-7.223a.555.555 0 0 1 .555-.555h5.556a.556.556 0 0 1 .555.555z"
        />
      </mask>
      <g mask="url(#home_svg__mask0_6875_6147)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=home.js.map
